export default __webpack_public_path__ + "fk-cp-zion/img/flipkart-plus_8d85f4.png";